import React from 'react';
import PropTypes from 'prop-types';
import Flag from 'components/Flag';
import COUNTRIES from 'assets/data/countries';
import { A } from 'components/Typography';
import { FORBIDDEN_DESTINATIONS_SW } from 'products/nomad_insurance/constants';
import { ExclusionsBox, ExcludedDestinations, Destination } from './styled';

const Exclusions = ({ homeCountry }) => {
  const forbiddenDestinations = FORBIDDEN_DESTINATIONS_SW;
  const country = COUNTRIES.find((c) => c.code === homeCountry);

  return (
    <ExclusionsBox>
      We are currently unable to provide coverage for the following countries:
      <ExcludedDestinations>
        {forbiddenDestinations.map((destination) => {
          const countryName = COUNTRIES.find((c) => c.code === destination)?.name;
          return (
            <Destination key={destination}>
              <Flag code={destination} height={16} /> {countryName}
            </Destination>
          );
        })}
        <Destination>
          <Flag code={country.code} height={16} /> {country.name} (home country)
        </Destination>
      </ExcludedDestinations>
      We can cover you for brief visits up to {homeCountry === 'US' ? 15 : 30} days in
      your home country for every 90 days you spend abroad. Read more about that{' '}
      <A
        target="_blank"
        rel="noopener noreferrer"
        href="/nomad-insurance/faq?searchStr=Is%20any%20coverage%20provided%20while%20i%20am%20in%20my%20home%20country"
      >
        here
      </A>
      .
    </ExclusionsBox>
  );
};

Exclusions.propTypes = {
  homeCountry: PropTypes.string.isRequired
};

export default Exclusions;
